import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

import { FaBuilding, FaShoppingCart, FaParking, FaHelicopter } from "react-icons/fa";
import { MdHeight, MdBusiness, MdApartment } from "react-icons/md";
import { GiMusicalNotes } from "react-icons/gi";
import { TbBuildingSkyscraper, TbTower } from "react-icons/tb";
import { IoCarSportSharp } from "react-icons/io5";
import { PiBlueprintLight } from "react-icons/pi";

import heroImg from '../../../assets/bhutanicyber/boxImg.jpg'
import inner1 from '../../../assets/bhutanicyber/image 1.jpg'
import inner2 from '../../../assets/bhutanicyber/image 2.jpg'
import inner3 from '../../../assets/bhutanicyber/image 3.jpg'
import inner4 from '../../../assets/bhutanicyber/image 4.webp'
import inner5 from '../../../assets/bhutanicyber/image 5.jpg'

import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';

const BhutaniCyberthum = () => {
    const location = useLocation();
    const [openImgModal, setOpenImgModal] = useState(false)
    const innerImgs = [inner1, inner2, inner3, inner4, inner5]
    const [selectedImgIndex, setSelectedImgIndex] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const handleOpenModal = (index) => {
        setOpenImgModal(false);
        setSelectedImgIndex(index);
        setTimeout(() => {
            setOpenImgModal(true);
        }, 100);
    };

    const points = [
        {
            icon: TbBuildingSkyscraper,
            title: "North India’s Tallest Commercial Tower",
        },
        {
            icon: TbTower,
            title: "Two 46-Floor Iconic Towers",
        },
        {
            icon: GiMusicalNotes,
            title: "One of North India’s Largest Musical Fountain",
        },
        {
            icon: FaShoppingCart,
            title: "Mall in the Sky",
        },
        {
            icon: MdBusiness,
            title: "LEED Platinum Certified Building",
        },
        {
            icon: FaHelicopter,
            title: "A Helipad and Ample Parking Facilities",
        },
        {
            icon: FaBuilding,
            title: "The Office Towers Are Designed as a Vertical Campus – Distinct Zones for Distinct Workmodes",
        },
        {
            icon: MdApartment,
            title: "Built-up Area with Basement: 4,18,376.877 sq mt",
        },
        {
            icon: MdHeight,
            title: "Tower Height: 213.7 Metres",
        },
        {
            icon: TbBuildingSkyscraper,
            title: "Tallest Commercial Tower in NCR Region",
        },
        {
            icon: TbTower,
            title: "Building Heights: Ground + 46 Floor (Tower A & B)",
        },
        {
            icon: PiBlueprintLight,
            title: "Floor to Floor Height: Office – 4.5M Each, Commercial – 6.9M Each",
        },
        {
            icon: IoCarSportSharp,
            title: "Parking Spaces: 421 Open Parking",
        },
        {
            icon: FaParking,
            title: "4950 Covered Basement Parking",
        },
    ]

    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[500px] bg-cover bg-center mb-5"
                style={{ backgroundImage: `url('${heroImg}')` }}
            ></div>

            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div class="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify">Bhutani Cyberthum is a futuristic commercial real estate marvel located in Sector 140A,
                                Noida Expressway, Greater Noida. Developed by the Bhutani Group, this mixed-use complex spans 26.8 acres
                                and features two towering 46-story buildings.</p>
                            <p className="text-md text-gray-700 mb-4 text-justify"> The project is designed to be a vertical campus, offering a blend of office spaces,
                                retail areas, co-working zones, and a unique "mall in the sky". It also boasts one of India's largest gaming and entertainment zones,
                                along with majestic musical fountains and lush landscaping.</p>
                            <p className="text-md text-gray-700 mb-4 text-justify"> Bhutani Cyberthum is strategically located near key IT companies like Accenture, HCL, TCS,
                                Wipro, Dell, Barclays, Oracle, and Samsung, making it an ideal hub for businesses. The project is LEED Platinum certified, ensuring sustainability
                                and energy efficiency.<b />
                                With its state-of-the-art infrastructure and modern amenities, Bhutani Cyberthum is set to redefine the commercial landscape of Noida and set new
                                benchmarks for future developments.</p>
                        </div>
                        <div className="max-w-4xl mx-auto p-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {points.map((point, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center bg-white p-4 rounded-lg shadow hover:shadow-lg transition-shadow duration-300"
                                    >
                                        {React.createElement(point.icon, {
                                            size: 24,
                                            color: "green",
                                            className: "w-6 h-6 mr-3",
                                        })}
                                        <span className="text-gray-700 font-medium">{point.title}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            <h2 className="text-2xl font-semibold text-gray-800 m-4">
                Projects Highlights
            </h2>
            {openImgModal && (
                <ImageModal
                    images={innerImgs}
                    openImg={openImgModal}
                    selectedImgIndex={selectedImgIndex}
                    onClose={() => setOpenImgModal(false)}
                />
            )}
            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
                {innerImgs.map((data, index) => (
                    <div
                        key={index}
                        onClick={() => handleOpenModal(index)}
                        className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                    >
                        <img src={data} alt="Bhutani"
                            className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
export default BhutaniCyberthum